import { camelCase } from 'change-case';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const camelCaseKeysPlainObject = <T1 extends Record<any, any>>(
  x: T1
): T1 =>
  Object.keys(x).reduce((acc, k) => {
    // @ts-ignore
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call
    acc[camelCase(k) as keyof typeof x] = x[k];
    return acc;
  }, {} as unknown as typeof x);

export const getNormalizedLibraryData = <
  TReturn,
  T1 extends {
    readonly data?: T1['data'] extends string ? string : T1['data'];
  }
>(
  item: T1
): TReturn => {
  if (typeof item?.data === 'string') {
    try {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-return
      return camelCaseKeysPlainObject(
        JSON.parse(item.data)
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
      ) as unknown as any;
    } catch {
      return undefined as TReturn;
    }
  }

  return item.data as unknown as TReturn;
};
